import React, { useEffect, useState } from 'react';
import { Modal, Descriptions, Card, Space, Button } from 'antd';
import { Rescues } from '@services/types';
import { Navigation } from '@constants/Navigation';
import api from '@services/api';
import { useHistory, useParams } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';

const InfoRescueModal = () => {
  const { id }: { id: string } = useParams();
  const history = useHistory();
  const [rescue, setRescue] = useState<Rescues>();

  const onClose = () => {
    history.push(Navigation.Rescue);
  };

  useEffect(() => {
    if (id) {
      api.rescue.getRescueById(id).then((data) => {
        setRescue(data);
      });
    }
  }, []);
  return (
    <Card
      title="Rescue info"
      extra={
        <Button icon={<ArrowLeftOutlined />} type="default" onClick={onClose}>
          Back to Rescue Page
        </Button>
      }
    >
      <Descriptions labelStyle={{ fontWeight: '500', fontSize: '16px' }} layout="horizontal" column={1} bordered>
        <Descriptions.Item label="Descriptions">{rescue?.description}</Descriptions.Item>
        <Descriptions.Item label="Hardware ID">{rescue?.hwId}</Descriptions.Item>
        <Descriptions.Item label="Usage ID">{rescue?.usId}</Descriptions.Item>
        <Descriptions.Item label="Final Url">
          <a target={'_blank'} rel={'noreferrer'} href={rescue?.finalUrl}>
            {rescue?.finalUrl}
          </a>
        </Descriptions.Item>
      </Descriptions>
      <Descriptions
        title="Current Rescue Firmware"
        labelStyle={{ fontWeight: '500', fontSize: '16px' }}
        layout="horizontal"
        column={1}
        bordered
        style={{ marginTop: '1em' }}
      >
        <Descriptions.Item label="Type">{rescue?.currentRescueFirmware?.type}</Descriptions.Item>
        <Descriptions.Item label="Version">{rescue?.currentRescueFirmware?.denormVersion}</Descriptions.Item>
      </Descriptions>
      {rescue?.lastRescueFirmware?.type.length && (
        <Descriptions
          title="Last Rescue Firmware"
          labelStyle={{ fontWeight: '500', fontSize: '16px' }}
          layout="horizontal"
          column={1}
          bordered
          style={{ marginTop: '1em' }}
        >
          <Descriptions.Item label="Type">{rescue?.lastRescueFirmware?.type}</Descriptions.Item>
          <Descriptions.Item label="Version">{rescue?.lastRescueFirmware?.denormVersion}</Descriptions.Item>
        </Descriptions>
      )}
    </Card>
  );
};

export default React.memo(InfoRescueModal);
